// extracted by mini-css-extract-plugin
export var hidden = "_tq-0";